<template>
  <div>
    <dx-description-label v-if="$te(`${translationKeyPrefix}.description`)">
      {{ $t(`${translationKeyPrefix}.description`) }}
    </dx-description-label>

    <dx-input
      :id="config.id"
      :value="value"
      :label="translatedLabel"
      :type="type"
      :disabled="config.readonly"
      :error="translatedError"
      @input="update"
      @blur="onBlur"
    />
  </div>
</template>

<script>
import { DxInput } from '@sumcumo/dextra-frontend-component-lib'
import DxDescriptionLabel from '~/components/DX-DescriptionLabel/DxDescriptionLabel'

export default {
  name: 'DXTextAdapter',
  components: {
    DxDescriptionLabel,
    DxInput,
  },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [Number, String],
      default: null,
    },
    error: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formatValid: null,
    }
  },
  computed: {
    type() {
      return this.config.contentType === 'day_month' ? 'daymonth' : 'text'
    },

    translationKeyPrefix() {
      if (this.config.source) {
        if (this.config.source.kind === 'values') {
          return `attributes.${this.config.source.key}.${this.config.source.originalId}`
        }

        return `${this.config.source.key}.${this.config.source.originalId}`
      }

      return ''
    },

    translatedLabel() {
      return this.$t(`${this.translationKeyPrefix}.label`)
    },

    translatedError() {
      if (!this.error) {
        return null
      }

      let key
      if (this.error.type === 'matches') {
        key = `errors.text.matches.${this.config.contentType}`
      } else if (this.error.type === 'dayMonth') {
        key = `errors.text.dayMonth.${this.formatValid ? 'date' : 'format'}`
      } else {
        key = `errors.text.${this.error.type}`
      }

      return this.$t(key, {
        ...this.error.params,
        label: this.translatedLabel,
      })
    },
  },
  methods: {
    update(newValue) {
      this.$emit('input', newValue)
    },
    onBlur() {
      this.formatValid = this.value?.match(/^[0-9]{1,2}\.[0-9]{1,2}\.$/)
      this.$emit('validate', this.config.id)
    },
  },
}
</script>
